var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehaviorSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#005597"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1890_11662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7333 18.3333C11.8 18.3333 10.925 18.1556 10.1083 17.8C9.29167 17.4444 8.58056 16.9639 7.975 16.3583C7.36944 15.7528 6.88889 15.0417 6.53333 14.225C6.17778 13.4083 6 12.5333 6 11.6C6 9.97778 6.51667 8.54722 7.55 7.30833C8.58333 6.06944 9.9 5.3 11.5 5C11.3 6.08889 11.3611 7.15908 11.6833 8.21058C12.0056 9.26208 12.5611 10.1828 13.35 10.9728C14.1389 11.7629 15.0583 12.3192 16.1083 12.6419C17.1583 12.9646 18.2333 13.0258 19.3333 12.8255C19.0444 14.4278 18.2778 15.7463 17.0333 16.7811C15.7889 17.8159 14.3556 18.3333 12.7333 18.3333ZM12.7333 17.3333C13.8444 17.3333 14.8556 17.0167 15.7667 16.3833C16.6778 15.75 17.4111 14.9444 17.9667 13.9667C16.9667 13.8778 16.0056 13.6472 15.0833 13.275C14.1611 12.9028 13.3472 12.3667 12.6417 11.6667C11.9361 10.9667 11.4 10.1583 11.0333 9.24167C10.6667 8.325 10.4389 7.37222 10.35 6.38333C9.37222 6.91667 8.56944 7.64167 7.94167 8.55833C7.31389 9.475 7 10.4889 7 11.6C7 13.1926 7.55741 14.5463 8.67222 15.6611C9.78704 16.7759 11.1407 17.3333 12.7333 17.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1890_11662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorSleep);
export default __webpack_public_path__ + "static/media/behavior-sleep.1b4c982f8081cc8fc22c1aa4afcaa26e.svg";
export { ForwardRef as ReactComponent };